/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleRegularTriggerDto } from './equipment-schedule-regular-trigger-dto';


export interface EquipmentRegularScheduleByIdResponseDto { 
    id?: string;
    name?: string | null;
    triggers?: Array<EquipmentScheduleRegularTriggerDto> | null;
    assignedCount?: number;
    createdDate?: string;
    updatedDate?: string | null;
}

